import React , { useState , useEffect } from 'react'
import { Link } from 'react-router-dom';
import { Input , Col, Label , Collapse  , CardBody } from 'reactstrap';
import Column_List from './Column_List';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { add_to_selected_Table_Payload, add_to_selected_tables, change_table_alias, remove_from_selected_table, remove_from_selected_table_payload } from '../../../../slices/Table_Details/reducer';
import * as url from "../../../../helpers/url_helper"
import config from '../../../../config';

const Table_list = ({ table , expandAll }) => {

    
    const { TableStructurePayload , selectedTables , Changed_Table_alias} = useSelector((state)=> state.Table_Details)
    const BotDetails = useSelector((state) => state.BotDetails.Bot_Details);
    
const [coll6, setcoll6] = useState(false);
const [table_select, settable_select] = useState( false)
const [table_alias, settable_alias] = useState( Changed_Table_alias[`${table.table_name}`]  ||table.table_alias)
const [select_all_column, setselect_all_column] = useState(false)

const dispatch = useDispatch()

useEffect(() => {
        
    
    
    if(table.table_selected || selectedTables.includes(`${table.table_name}`)  ){

        settable_select(true)
    }
    
    
    
    if(table.table_selected){
        dispatch(add_to_selected_tables(table.table_name))
    }


}, [table])

useEffect(() => {

    setcoll6(expandAll)
 
}, [expandAll])



const on_Adding_a_Table = ()=>{
       
    dispatch(add_to_selected_tables(table.table_name))
    dispatch(add_to_selected_Table_Payload({ table:table.table_name , columns:table.columns }))

}


const on_Removing_a_table = ()=>{
    dispatch(remove_from_selected_table(table.table_name))
    dispatch(remove_from_selected_table_payload(table.table_name))
}


const onChange_table_alias = (e)=>{
    if(selectedTables.includes(`${table.table_name}`)){

        settable_alias(e.target.value)

        dispatch(change_table_alias({ table_name:table.table_name , table_alias:e.target.value }))
    }
}


const t_coll6 = () => {
    setcoll6(!coll6);
    
    
};







  return (
    <Col md={12}>
    <div className={`alis   ${ (expandAll || coll6)  ?'bg-color-main':''}`}>
          <div className="typm">
              <div className="hstack gap-3">
                  <Link to="#" onClick={t_coll6} style={{ cursor: "pointer" }} className="link-default">
                      <i className="ri-arrow-right-s-fill"></i>
                  </Link>
                  {/* <Button color="light" onClick={t_coll7} style={{ cursor: "pointer" }} >
                        <i className="ri-filter-2-line"></i>
                    </Button> */}
              </div>
              <div className='check_container'>
                  <div class="form-check form-check-outline form-check-primary">
                      <Input onChange={(e)=>{
                        settable_select(e.target.checked)

                        if(e.target.checked){
                           on_Adding_a_Table()
                        }else{
                           on_Removing_a_table()
                        }
                      }} checked={table_select} class="form-check-input" type="checkbox" id="formCheck13" />
                  </div>
              </div>
              <div className='type_container'>
                  <span>{table.table_name}</span>
              </div>
          </div>
          <div className="atm_input">
              <Input value={table_alias} onChange={onChange_table_alias} type="Text" class="form-control" id="basiInput" placeholder={table.table_name} />
          </div>
      </div>
       
       <div className="typm_input">
        <Collapse isOpen={coll6} id="collapseWithicon">
        <div className="mb-0">
            <div className='inner_body_wrap'>
            <div className='all_select'>
        <div className="form-check mb-2">
                <Input 
                checked={select_all_column} 
                 onChange={(e)=>{
                    
                    
                    setselect_all_column(e.target.checked)
                }}  disabled={!table_select} defaultChecked={true} className="form-check-input" type="checkbox" id="formCheck1" />
                <Label className="form-check-label" htmlFor="formCheck1">
                    Select All
                </Label>
            </div>
       </div>
        {table.columns.map((ele, index)=>{
            return <Column_List setselect_all_column={setselect_all_column} select_all_column={select_all_column} table_select={table_select} column={ele}  coll6={coll6} table_name={table.table_name} pre_selected={table.table_selected}  />
        })}
          </div>
                            </div>
                        </Collapse>
         </div>                
      
     
      </Col>
  )
}

export default Table_list